import { MessageBox } from "element-ui";
import website from "@/config/website";
import { gotoReLogin } from "@/utils/ncnp";


export function getCurrentTime() {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0"); // 月份从0开始，需+1
  const day = String(now.getDate()).padStart(2, "0");
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}`;
}

/**
 * 参数处理
 * @param {*} params  参数
 */
export function tansParams(params) {
  let result = "";
  for (const propName of Object.keys(params)) {
    const value = params[propName];
    var part = encodeURIComponent(propName) + "=";
    if (value !== null && value !== "" && typeof value !== "undefined") {
      if (typeof value === "object") {
        for (const key of Object.keys(value)) {
          if (
            value[key] !== null &&
            value[key] !== "" &&
            typeof value[key] !== "undefined"
          ) {
            let params = propName + "[" + key + "]";
            var subPart = encodeURIComponent(params) + "=";
            result +=
              subPart + encodeURIComponent(value[key]) + "&";
          }
        }
      } else {
        result += part + encodeURIComponent(value) + "&";
      }
    }
  }
  return result;
}

/**
 * 下载文件
 * @param fileArrayBuffer 文件流
 * @param filename 文件名
 * @param mimeType 文件类型
 */
export const downloadFile = (
  fileArrayBuffer,
  filename,
  mimeType = "application/octet-stream"
) => {
  let data = new Blob([fileArrayBuffer], { type: mimeType });
  if (typeof window.chrome !== "undefined") {
    // Chrome
    let link = document.createElement("a");
    link.href = window.URL.createObjectURL(data);
    link.download = filename;
    link.click();
  } else if (typeof window.navigator.msSaveBlob !== "undefined") {
    // IE
    let blob = new Blob([data], { type: "application/force-download" });
    window.navigator.msSaveBlob(blob, filename);
  } else {
    // Firefox
    let file = new File([data], filename, {
      type: "application/force-download",
    });
    window.open(URL.createObjectURL(file));
  }
};

/**
 * 下载excel
 * @param {blob} fileArrayBuffer 文件流
 * @param {String} filename 文件名称
 */
export const downloadXls = (fileArrayBuffer, filename) => {
  downloadFile(
    fileArrayBuffer,
    filename,
    "application/vnd.ms-excel,charset=utf-8"
  );
};

// 将换行符替换为<br>标签
export function formattedTextBr(textInput) {
  return textInput.replace(/\n/g, "<br>");
}

/**
 * 更新URL参数
 * @param {string} path 路径
 * @param {string} key 键
 * @param {string} value 值
 */
export function updateUrlParameter(path, key, value) {
  const url = new URL(path);
  const params = new URLSearchParams(url.search);
  params.set(key, value);
  // 保留hash部分
  const hash = url.hash;
  // 构建新URL
  const newUrl = `${url.origin}${url.pathname}?${params.toString()}${hash}`;
  return newUrl;
}

/**
 * 更新URL参数（支持多键值对）
 * @param {string} path - 原始URL路径
 * @param {Object} params - 键值对参数对象 {key1: value1, key2: value2}
 * @returns {string} 更新后的完整URL
 */
export function updateUrlParameters(path, params = {}) {
  // 创建URL对象解析原始路径
  const url = new URL(path);
  const urlParams = new URLSearchParams(url.search);

  // 遍历参数对象并设置参数
  Object.entries(params).forEach(([key, value]) => {
    // 处理空值：当值为null/undefined时删除参数
    if (value == null) {
      urlParams.delete(key);
    } else {
      urlParams.set(key, value);
    }
  });

  // 保留hash锚点
  const hash = url.hash;
  
  // 构建新URL：处理特殊路径场景
  const pathname = url.pathname.replace(/\/$/, ''); // 移除末尾斜杠
  const origin = url.origin.replace(/\/$/, '');    // 移除origin末尾斜杠
  
  return `${origin}${pathname}?${urlParams.toString()}${hash}`;
}

/**
 * 未登录提示
 */
export function noLoginTip() {
  MessageBox.confirm("请先登录", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    // type: "warning",
  })
    .then(() => {
      // NCNP 用户走 welcome task_id=login，其余走 CA SSO
      gotoReLogin();
    })
    .catch(() => {

    });
}

/**
 * 企业未认证提示
 */
export function corpAuthAlert() {
  return MessageBox.alert(
    '<div style="display: flex; align-items: center; margin-bottom: 20px;"><span style="color: #E6A23C; font-size: 24px; margin-right: 10px;">⚠</span><span style="font-size: 16px; font-weight: bold;">提示</span></div><div style="margin-left: 34px; margin-bottom: 20px;">当前企业账号未完成认证！</div>',
    '',
    {
      dangerouslyUseHTMLString: true,
      confirmButtonText: '去认证',
      showClose: false,
      customClass: 'corp-auth-alert',
      callback: action => {
        // 点击去认证按钮，跳转到企业认证页面，在新标签页打开
        window.open(website.corpAuthUrl, '_blank');
        // 关闭弹框
        MessageBox.close();
      }
    }
  );
}
